import { render } from "./BulkActionView.vue?vue&type=template&id=334cd4b2"
import script from "./BulkActionView.vue?vue&type=script&lang=js"
export * from "./BulkActionView.vue?vue&type=script&lang=js"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__